import React from 'react';

const Footer = () => {
    return (
        <footer className="w-full py-8 mt-auto flex flex-col items-center justify-center border-t border-border/50 bg-background/50 backdrop-blur-sm relative z-10">
            <div className="flex flex-col items-center gap-1 opacity-90 hover:opacity-100 transition-opacity duration-300">
                {/* was text-white/X — a hardcoded literal that never flips with theme, sitting on
                    bg-background/50 (a token that DOES flip). Invisible-to-illegible on the 2
                    light-background themes (light, arctic), where --background is near-white.
                    text-muted-foreground is the semantic token already tuned for legibility
                    against --background in every theme. */}
                <p className="text-[10px] font-black uppercase tracking-[0.3em] text-muted-foreground">
                    Powered By <span className="text-primary font-black">The Iberian Engine Inc.</span>
                </p>
                <p className="text-[8px] font-bold text-muted-foreground/70 uppercase tracking-widest">
                    Advanced Content Architecture
                </p>
            </div>
        </footer>
    );
};

export default Footer;
